module.exports = __webpack_public_path__ + "static/media/it.f95bf7de.jpg";